var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "marketing-preferences-attributes__container" },
    [
      _c(
        "h1",
        {
          staticClass:
            "marketing-preferences-attributes__title typographies-heading-h1"
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$t.__(
                  "marketing.preferences.attributes.MarketingPreferencesAttributes.title"
                )
              ) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "p",
        {
          staticClass:
            "marketing-preferences-attributes__description typographies-paragraph-medium-regular"
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.$t.__(
                  "marketing.preferences.attributes.MarketingPreferencesAttributes.description"
                )
              ) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c("MarketingPreferencesAttributesTable", {
        attrs: {
          attributes: _vm.synchronizableAttributes,
          categories: _vm.categories,
          isLoading: _vm.isLoading
        },
        on: {
          "update:isLoading": function(newValue) {
            _vm.isLoading = newValue
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "marketing-preferences-attributes__footer" },
        [
          _c(
            "CompassTooltip",
            {
              attrs: {
                disabled: !_vm.synchronizationInProgress,
                content: _vm.$t.__(
                  "marketing.preferences.attributes.MarketingPreferencesAttributes.synchronization_already_start"
                ),
                placement: "top-end"
              }
            },
            [
              _c("CompassButton", {
                attrs: {
                  label: _vm.$t.__("common.actions.synchronise"),
                  disabled:
                    _vm.synchronizationInProgress || !_vm.hasChangesToAttributes
                },
                on: { click: _vm.openAttributesRevisionDiffModal }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          attrs: {
            title: _vm.$t.__(
              "marketing.preferences.attributes.MarketingPreferencesAttributes.synchronization_details"
            ),
            visible: _vm.displayAttributesRevisionDiffModal,
            size: "large"
          },
          on: {
            "update:visible": function($event) {
              _vm.displayAttributesRevisionDiffModal = $event
            }
          }
        },
        [
          _c("template", { slot: "default" }, [
            _c(
              "div",
              {
                staticClass: "marketing-attributes-revision-diff-modal__content"
              },
              [
                _c(
                  "CompassTabs",
                  {
                    staticClass:
                      "marketing-attributes-revision-diff-modal__tabs",
                    model: {
                      value: _vm.selectedModalTab,
                      callback: function($$v) {
                        _vm.selectedModalTab = $$v
                      },
                      expression: "selectedModalTab"
                    }
                  },
                  [
                    _vm.hasCreatedAttributes
                      ? _c(
                          "CompassTabPane",
                          {
                            attrs: {
                              label: _vm.$t.__(
                                "marketing.preferences.attributes.MarketingPreferencesAttributes.synchronized_fields"
                              ),
                              name: "create"
                            }
                          },
                          [
                            _c("MarketingPreferencesAttributesRevisionTab", {
                              attrs: {
                                attributes: _vm.attributesRevisionDiff.create
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.hasDeletedAttributes
                      ? _c(
                          "CompassTabPane",
                          {
                            attrs: {
                              label: _vm.$t.__(
                                "marketing.preferences.attributes.MarketingPreferencesAttributes.desynchronized_fields"
                              ),
                              name: "delete"
                            }
                          },
                          [
                            _c("MarketingPreferencesAttributesRevisionTab", {
                              attrs: {
                                attributes: _vm.attributesRevisionDiff.delete
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.hasDeletedAttributes
                  ? _c("CompassAlert", {
                      attrs: {
                        description: _vm.$t.__(
                          "marketing.preferences.attributes.MarketingPreferencesAttributes.careful_about_desynchronize_fields"
                        ),
                        "show-close": false,
                        type: "warning"
                      }
                    })
                  : _vm._e()
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "div",
              {
                staticClass: "marketing-attributes-revision-diff-modal__footer"
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "marketing-attributes-revision-diff-modal__footer-buttons"
                  },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__(
                          "marketing.preferences.attributes.MarketingPreferencesAttributes.back_to_selection"
                        ),
                        type: "secondary"
                      },
                      on: {
                        click: function($event) {
                          _vm.displayAttributesRevisionDiffModal = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__(
                          "marketing.preferences.attributes.MarketingPreferencesAttributes.start_synchronization"
                        ),
                        disabled:
                          !_vm.hasCreatedAttributes && !_vm.hasDeletedAttributes
                      },
                      on: { click: _vm.synchronizeAttributes }
                    })
                  ],
                  1
                )
              ]
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }